/**
 * Configuración global de actions
 */
export const DO_ROUTE = "DO_ROUTE";
export const DO_ROUTE_PUSH = "DO_ROUTE_PUSH";
export const DO_IS_LOADING = "DO_IS_LOADING";
export const DO_REQUEST_API = "DO_REQUEST_API";
export const DO_PASO1 = "DO_PASO1";
export const DO_PASO1_SUCCESS = "DO_PASO1_SUCCESS";
export const DO_PASO2 = "DO_PASO2";
export const DO_PASO3 = "DO_PASO3";
export const DO_PASO4 = "DO_PASO4";
export const DO_PASO4_SUCCESS = "DO_PASO4_SUCCESS";
export const DO_PASO_ERROR = "DO_PASO_ERROR";
export const DO_MENSAJE = "DO_MENSAJE";
export const DO_CLICK_TRACKING = "DO_CLICK_TRACKING";
export const DO_MOCK = "DO_MOCK";
export const DO_NOTIFICATION_TOAST = "DO_NOTIFICATION_TOAST";
export const DO_NOTIFICATION_TOAST_RESET = "DO_NOTIFICATION_TOAST_RESET";
